module.exports = __webpack_public_path__ + "img/77940.2c69616b.jpg";